function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export default class DialogHandler {
  constructor(config, open, close, dispatchEvent, addDataListener) {
    _defineProperty(this, "isOpen", false);
    _defineProperty(this, "result", undefined);
    _defineProperty(this, "listeners", []);
    this._open = open;
    this._close = close;
    this._config = config;
    this._dispatchEvent = dispatchEvent;
    this._addDataListener = addDataListener;
  }
  async open() {
    if (this.isOpen) {
      throw new Error('cannot open a dialog which is already open');
    }
    const res = await new Promise(async resolve => {
      const callback = data => {
        this.isOpen = false;
        resolve(data);
      };
      this.isOpen = true;
      this.dialogId = await this._open(this._config, callback);

      // console.log('dialogId', this.dialogId);

      this._addDataListener(this.dialogId, data => {
        // console.log('[DialogHandler]dataListener', this.dialogId, data);
        this.listeners.forEach(cb => cb(data));
      });
    });
    return this.result = res;
  }
  close(buttonType, data) {
    if (!this.isOpen) {
      return;
    }
    this.isOpen = false;
    this._close(this.dialogId, data);
  }
  dispatchEvent(data) {
    if (!this.isOpen) {
      return;
    }
    this._dispatchEvent(this.dialogId, data);
  }
  addDataListener(listener) {
    this.listeners.push(listener);
  }
  removeDataListener(listener) {
    const index = this.listeners.findIndex(l => l === listener);
    if (index > -1) {
      this.listeners.splice(index, 1);
    }
  }
  getResult() {
    return this.result;
  }
}